import type { ReplyButton, ReplyKeyboard } from "@velizhanin-dev/bot-scenario"
import { AppWindow, MapPin, Phone } from "lucide-react"
import type { TestChatEntry } from "@/entities/bot-builder"
import { cn } from "@/shared/lib/utils"
import { Button } from "@/shared/ui/button"
import { STYLE_CLASSES, TG } from "../lib/telegram-theme"

/** Какая клавиатура из кнопок сейчас открыта у пользователя, как её показал бы Telegram. */
export function currentReplyKeyboard(transcript: TestChatEntry[]): ReplyKeyboard | null {
	let keyboard: ReplyKeyboard | null = null
	for (const entry of transcript) {
		// Одноразовую клавиатуру Telegram прячет, как только пользователь ответил.
		if (entry.from === "user" && keyboard?.oneTime) keyboard = null
		if (entry.from !== "bot") continue
		if (entry.replyKeyboard) keyboard = entry.replyKeyboard
		else if (entry.removeKeyboard) keyboard = null
	}
	return keyboard
}

export function ReplyKeyboardView({
	keyboard,
	disabled,
	onPress,
}: {
	keyboard: ReplyKeyboard
	disabled: boolean
	onPress: (button: ReplyButton) => void
}) {
	return (
		<div
			className="space-y-1.5 px-2 pb-2"
			style={{ backgroundColor: TG.panel }}
			role="group"
			aria-label="Клавиатура бота"
		>
			{keyboard.rows.map((row, rowIndex) => (
				<div key={rowIndex} className="flex gap-1.5">
					{row.map((button, index) => (
						<Button
							key={index}
							type="button"
							variant="ghost"
							disabled={disabled}
							onClick={() => onPress(button)}
							className={cn(
								"h-auto min-w-0 flex-1 gap-1.5 rounded-lg px-2 py-2.5 text-[13px] font-medium text-white hover:bg-[#2c3a4a]",
								TG.field,
								button.style && STYLE_CLASSES[button.style],
							)}
						>
							{button.kind === "contact" ? <Phone className="h-3.5 w-3.5 shrink-0" /> : null}
							{button.kind === "location" ? <MapPin className="h-3.5 w-3.5 shrink-0" /> : null}
							{button.kind === "web_app" ? <AppWindow className="h-3.5 w-3.5 shrink-0" /> : null}
							<span className="truncate">{button.label}</span>
						</Button>
					))}
				</div>
			))}
		</div>
	)
}

export function TypingBubble() {
	return (
		<div
			className={cn(
				"flex w-fit items-center gap-1 rounded-2xl rounded-bl-md px-3.5 py-3",
				TG.incoming,
			)}
			role="status"
			aria-label="Бот печатает"
		>
			{[0, 1, 2].map((index) => (
				<span
					key={index}
					className="h-1.5 w-1.5 animate-bounce rounded-full bg-white/60"
					style={{ animationDelay: `${index * 140}ms` }}
				/>
			))}
		</div>
	)
}
